import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonIcon from 'components/IconButton';
import { CreateIcon } from 'Icons';
import PropTypes from 'prop-types';
import AttendanceTrackingShiftForm from './attendanceTrackingShiftForm';
import { attendanceSelectors } from '../';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

const CreateShiftActivityButton = () => {
  const { t } = useTranslation();
  const [openShiftModal, setOpenShiftModal] = useState(false);
  const attendanceDetails = useSelector(state =>
    attendanceSelectors.getAttendanceDetailsRaw(state),
  );
  const shiftFormProps = {
    values: {
      id: attendanceDetails.id,
    },
  };

  const onIconClick = () => {
    setOpenShiftModal(true);
  };

  return (
    <Box
      typeof="div"
      display={'flex'}
      flexDirection={'column'}
      alignItems={'flex-start'}
    >
      <ButtonIcon
        noHorizontalPadding
        title={t('Add shift item')}
        component={CreateIcon}
        onClick={() => onIconClick()}
        iconProps={{
          fontSize: 'inherit',
        }}
      />
      {openShiftModal && (
        <AttendanceTrackingShiftForm
          closeForm={() => setOpenShiftModal(false)}
          formProps={shiftFormProps}
        />
      )}
    </Box>
  );
};
CreateShiftActivityButton.propTypes = {
  view: PropTypes.string,
};

export default CreateShiftActivityButton;
